var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"ma-0",attrs:{"outline":"","color":"warning","value":_vm.mensagem}},[_c('div',{staticClass:"title mb-1"},[_vm._v("Importante")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.mensagem)}})])}
var staticRenderFns = []

export { render, staticRenderFns }